import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getWebsitesPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/vyvoj/web-na-miru",
		[Locale.en]: "/development/websites",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
